<template>
  <div class="login-page">
    <div class="login-page_box">
      <div class="login-page_logo">
        <sub v-if="isDev">dev</sub>
        <img src="/img/logos/fact-logo-50-black.svg" alt="logo" />
      </div>
      <div class="text-h3  login-page_title mb-2 text-center" v-text="`Вход в систему`" />
      <transition name="slide">
        <div v-if="error" class="error--text text-center mb-1">
          Ошибка! {{ errorMessage }}
        </div>
      </transition>
      <v-form ref="form" action="#" @submit="login">
        <v-text-field-simplemask
          v-model="phone"
          :options="{
            inputMask: '+#(###)###-##-##',
            outputMask: '###########',
            empty: null,
            applyAfter: false,
            alphanumeric: true,
            lowerCase: false,
          }"
          label="Номер телефона"
          placeholder="+7(000)000-00-00"
          required
        />
        <v-text-field
          v-model="password"
          type="password"
          label="Пароль"
          required
        />

        <div class="text-center">
          <v-btn
            :loading="load"
            type="submit"
            rounded
            large
            color="primary"
            block
            @click.prevent="login"
          >
            Войти
          </v-btn>
        </div>
      </v-form>
      <div v-if="success" class="login-page_loading">
        <v-sheet
          color="green"
          elevation="5"
          height="100"
          rounded
          width="200"
          type="success"
          class="d-flex align-center justify-center"
          dark
        >
          <span class="font-weight-medium">Вход в аккаунт</span>
        </v-sheet>
      </div>
    </div>
  </div>
</template>

<script>
  import User from './../models/user'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        user: new User('', ''),
        phone: '',
        password: '',
        load: false,
        success: false,
        error: false,
        errorMessage: '',
      }
    },
    computed: {
      ...mapGetters({
        isDev: 'app/appIsDev',
      }),
      loggedIn () {
        return this.$store.getters['auth/loggedIn']
      },
    },
    mounted () {
      if (this.loggedIn) {
        this.$router.push({ path: '/orders', name: 'orders' })
      }
    },
    methods: {
      login () {
        this.clearError()

        if (!this.phone || !this.password) {
          this.setError('Введите телефон и пароль!')
          return
        }

        this.load = true
        const payload = {
          phone: this.phone,
          password: this.password,
        }
        this.$store.dispatch('auth/login', payload)
          .then(() => {
            // this.$router.push('/orders')
            this.success = true
            window.location.href = '/'
          })
          .catch((error) => {
            const text = (error.response && error.response.data.message) || error.message || error.toString()
            this.setError(text)
          })
          .finally(() => {
            this.load = false
          })
      },
      clearError () {
        this.error = false
        this.errorMessage = ''
      },
      setError (text) {
        this.error = true
        this.errorMessage = text
      },
    },
  }
</script>

<style scoped lang="less">
.login-page {
  //width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  //background-image: linear-gradient(to top, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url("/img/bgr/bg4.jpg");
  //background-image: linear-gradient(to top, rgba(0, 51, 255 ,0.4), rgba(0, 51, 255, 0.3)), url("/img/bgr/bg4.jpg");
  // background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(0, 52, 255, 0.4)), url("/img/bgr/bg4.jpg");
  //background-image: url("/img/bgr/bg4.jpg");
  background-position: center center;
  min-height: 100vh;
  margin: -12px;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #000;
  background: radial-gradient(ellipse, #363636, #000);

  .primary {
    background-color: #ff9100 !important;
    border-color: #ff9100 !important;
  }

  &_loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.75);
    position: absolute;
    top: 0;
    left: 0;
  }

  &_box {
    max-width: calc(100% - 40px);
    width: 400px;
    background-color: #fff;
    padding: 25px 35px;
    border-radius: 10px;
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    position: relative;
  }

  &_logo {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 40px;

    img {
      width: 250px;
      max-width: 100%;
      display: block;
    }

    sub {
      font-size: 10px;
      text-transform: uppercase;
      margin-right: 10px;
    }
  }

  &_title {
    // font-weight: 500;
  }

  .media-sm({
    &_box {
      padding: 20px;
    }

    &_logo {
      margin-bottom: 24px;
    }

    &_title.text-h3 {
      font-size: 1.8rem !important;
      line-height: 1.2;
    }
  });
}
</style>
